exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "@media (min-width:992px){ul.admin-nav[data-v-472b35ea]{padding:0 4rem}}", ""]);

// exports
